import type { PAGE_POSITIONS } from 'types';

import gtm from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  related_term: string;
  search_term: string;
};

class RelatedSearchClickEvent extends UserEvent<EventData> {
  sendToGtm() {
    if (this.data.isBot) return;

    const page_position: PAGE_POSITIONS = 'Header';

    gtm.pushToDataLayer({
      event: 'related_search_click',
      page_position,
      related_term: this.data.related_term,
      search_term: this.data.search_term
    });
  }
}

export default RelatedSearchClickEvent;
